import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './components/Header';
import Footer from './components/Footer';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import Home from './pages/Home';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword';
import Profile from './pages/Profile';
import CreateListing from './pages/CreateListing';
import EditListing from './pages/EditListing';
import Listing from './pages/Listing';
import Category from './pages/Category';
import Offers from './pages/Offers';
import About from './pages/About';
import Contact from './pages/Contact';

// Admin Pages
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProperties from './pages/admin/AdminProperties';
import AdminUsers from './pages/admin/AdminUsers';
import AdminContacts from './pages/admin/AdminContacts';

function App() {
  return (
    <>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Routes>
          {/* Public Routes */}
          <Route 
            path="/" 
            element={
              <>
                <Header />
                <Home />
                <Footer />
              </>
            } 
          />
          <Route 
            path="/sign-in" 
            element={
              <>
                <Header />
                <SignIn />
                <Footer />
              </>
            } 
          />
          <Route 
            path="/sign-up" 
            element={
              <>
                <Header />
                <SignUp />
                <Footer />
              </>
            } 
          />
          <Route 
            path="/forgot-password" 
            element={
              <>
                <Header />
                <ForgotPassword />
                <Footer />
              </>
            } 
          />
          <Route 
            path="/about" 
            element={
              <>
                <Header />
                <About />
                <Footer />
              </>
            } 
          />
          <Route 
            path="/contact" 
            element={
              <>
                <Header />
                <Contact />
                <Footer />
              </>
            } 
          />
          <Route 
            path="/category/:categoryName" 
            element={
              <>
                <Header />
                <Category />
                <Footer />
              </>
            } 
          />
          <Route 
            path="/category/:categoryName/:listingId" 
            element={
              <>
                <Header />
                <Listing />
                <Footer />
              </>
            } 
          />
          <Route 
            path="/offers" 
            element={
              <>
                <Header />
                <Offers />
                <Footer />
              </>
            } 
          />

          {/* Protected Routes (Any authenticated user) */}
          <Route element={<PrivateRoute />}>
            <Route 
              path="/profile" 
              element={
                <>
                  <Header />
                  <Profile />
                  <Footer />
                </>
              } 
            />
            <Route 
              path="/create-listing" 
              element={
                <>
                  <Header />
                  <CreateListing />
                  <Footer />
                </>
              } 
            />
            <Route 
              path="/edit-listing/:listingId" 
              element={
                <>
                  <Header />
                  <EditListing />
                  <Footer />
                </>
              } 
            />
          </Route>

          {/* Admin Routes (Admin users only) */}
          <Route element={<AdminRoute />}>
            <Route 
              path="/admin" 
              element={<AdminDashboard />}
            />
            <Route 
              path="/admin/properties" 
              element={<AdminProperties />}
            />
            <Route 
              path="/admin/users" 
              element={<AdminUsers />}
            />
            <Route 
              path="/admin/contacts" 
              element={<AdminContacts />}
            />
          </Route>
        </Routes>
      </Router>

      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </>
  );
}

export default App;
